/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
import { CommonModule, LocationStrategy } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EIcons } from '@core/enums/icons.enum';
import { DestroyerService } from '@shared/services/destroyer.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [DestroyerService],
})
export class IconModule {
  private domSanitizer = inject(DomSanitizer);
  private locationStrategy = inject(LocationStrategy);
  public matIconRegistry = inject(MatIconRegistry);

  baseHref = this.locationStrategy.getBaseHref();
  path = `${this.baseHref}assets/icons`;
  icons = EIcons;

  constructor() {
    this.addIcons(Object.values(EIcons));
  }

  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  addIcons(icons: string[]) {
    icons.forEach((name) =>
      this.matIconRegistry.addSvgIcon(name, this.setPath(`${this.path}/${name}.svg`)),
    );
  }
}
